const errors = {
    login: {
        205: `We weren't able to log you in using Facebook. Please <a href='${WEBROOT}/contact-us/'>contact Customer Service</a>.`,
        208: "We're experiencing some difficulties. Please try again in a few minutes.",
    },
    register: {
        205: "We weren't able to create your account using Facebook. Please register with your email address.",
        208: "We're experiencing some difficulties. Please try again in a few minutes.",
    },
};

export default class ErrorHelper {
    static getErrorMessage(errorCode, context, defaultMessage) {
        let message = defaultMessage;
        // eslint-disable-next-line no-prototype-builtins
        if (errors[context].hasOwnProperty(errorCode)) {
            message = errors[context][errorCode];
        }
        return message;
    }
}
